export const fhbLangVi = {
    messageFhb: {
        selectLanguage: "Chọn một ngôn ngữ"
    }

};
